<template>
	<div>
		<div class="row">
			<div class="col-xs-12 col-md-4 col-md-offset-4">
				{{ $t('MAIN_CONTENT.InteractiveScheduler.useThisScreenToChangeClassSchedule') }}
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-md-4 col-md-offset-4">
				<select name="scheduleList" class="form-control" v-model="selectedClass">
					<option value="">
						{{ $t('MAIN_CONTENT.InteractiveScheduler.selectScheduleToAccess') }}
					</option>
					<option v-for="(classlist, classIndex) in classList"
									:value="classlist.ISCHED_VIEW_CODE"
									:key="`class_${classIndex}`">
						{{ classlist.SCHOOL_TITLE }} - {{ classlist.ISCHED_VIEW_DESC }}
					</option>
				</select>
			</div>
			<div class="col-xs-12 col-md-2 col-md-offset-2" v-if="!!selectedClass && printLink">
				<a
					target="_blank"
					:href="printLink"
					class="btn btn-primary"
				>
					<i class="fas fa-print" aria-hidden="true"></i> {{ $t( 'MAIN_CONTENT.InteractiveScheduler.print' ) }}
					<aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" />
				</a>
			</div>
		</div>

		<br />

		<template v-if="!!messages">
			<div v-for="(message, messageIndex) in messages"
					 :key="`message_${messageIndex}`"
					 aria-live="polite">
				<div class="col-xs-12 alert alert-info"
						 :class="{'alert-success': message.TYPE === 'success', 'alert-danger': message.TYPE === 'error', 'alert-warning': message.TYPE === 'warning'}"
						 v-if="!!message && !!message.TEXT"
						 :role="message.TYPE === 'error' ? 'alert' : 'status'"
						 aria-atomic="true">
					<p>{{ message.TEXT }}</p>
				</div>
			</div>
		</template>

		<student-scheduler
			:selectedStudent="selectedStudent"
			:selectedCourse="selectedCourse"
			:classList="classList"
			:availableCourses="availableCourses"
			:selectedClass="selectedClass"
			:showModal="showModal"
			:showConfirm="showConfirm"
			:projectType="'CWP'"
			:canAdd="getSelectedClass.STUDENT_MAY_ADD_FLG === 'Y'"
			:canRemove="getSelectedClass.STUDENT_MAY_DROP_FLG === 'Y'"
			:periodDaysText="$t( 'MAIN_CONTENT.InteractiveScheduler.periodDays' )"
			:emptyText="$t( 'MAIN_CONTENT.InteractiveScheduler.empty' )"
			:loadingMessageText="$t( 'MAIN_CONTENT.InteractiveScheduler.loadingMessage' )"
			:courseConflictMessage="$t( 'MAIN_CONTENT.InteractiveScheduler.courseConflictMessage' )"
			:filterByText="$t( 'MAIN_CONTENT.InteractiveScheduler.filterBy' )"
			:allDepartmentsText="$t( 'MAIN_CONTENT.InteractiveScheduler.allDepartments' )"
			:showCourseDescriptionsText="$t( 'MAIN_CONTENT.InteractiveScheduler.showCourseDesctions' )"
			:showUnavailableClassesText="$t( 'MAIN_CONTENT.InteractiveScheduler.showUnavailableClasses' )"
			:confirmText="$t( 'commonText.confirm' )"
			:cancelText="$t( 'commonText.cancel' )"
			:closeText="$t( 'MAIN_CONTENT.commonContent.closeButton' )"
			v-if="!!selectedClass"
			@loadAvailableCourses="loadAvailableCourses"
			@closeModal="closeModal"
			@addCourse="addCourse"
			@removeCourse="removeCourse"
			@updateConfirm="updateConfirm"
		/>
	</div>
</template>

<script>
	import AvailableClasses from '../api/AvailableClasses.js';
	import StudentSchedule from '../api/StudentSchedule.js';
	import ScheduleWindow from '../api/ScheduleWindow.js';

	import StudentScheduler from 'COMMONS/StudentScheduler/StudentScheduler.vue';

	import { mapGetters } from 'vuex';

	export default {
		name: 'InteractiveScheduler',
		data() {
			return {
				selectedClass: '',
				filterBy: '',
				messages: [],
				showModal: false,
				showConfirm: false,
				conflict: false,
				showDescriptions: false,
				showUnavailable: false,
				classList: [],
				selectedCourse: {},
				availableCourses: [],
				activeTopic: {
					period:	'',
					day:		'',
					course:	'',
					topics:	[]
				},
				selectedMatrixCell: {
					mp:			'',
					period:	'',
					day:		''
				},
				printLink:'',
				scheduleWindow: {},
			};
		},
		computed: {
			...mapGetters(['selectedStudent']),
			getSelectedClass() {
				let selected = {};

				for(let s in this.classList) {
					let classSelection = this.classList[s];

					if(classSelection.ISCHED_VIEW_CODE === this.selectedClass) {
						selected = classSelection;
					}
				}

				return selected;
			}
		},
		components: {
			StudentScheduler
		},
		watch: {
			selectedClass() {
				if(!!this.selectedClass) {
					this.getPrintScheduleLink();
					for(let c in this.classList) {
						let currentClass = this.classList[c];

						if(currentClass.ISCHED_VIEW_CODE === this.selectedClass) {
							this.loadScheduler(currentClass);
							this.loadScheduleWindow(currentClass);

						}
					}
				}
			}
		},
		methods: {
			loadClassList() {
				const self = this;

				let classes = new AvailableClasses({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				const promise = classes.get();

				promise.then(response => {
					self.$set(self, 'classList', classes.getResponseData());

					if(self.classList.length === 1 && !!self.$route.query.scheduleID) {
						self.selectedClass = self.classList[0].ISCHED_VIEW_CODE;

						self.loadScheduler(self.getSelectedClass);
						self.loadScheduleWindow(self.getSelectedClass);
					} else if(!!self.$route.query.scheduleID) {
						let classExists = false;

						for(let c in self.classList) {
							let list = self.classList[c];

							if(self.$route.query.scheduleID === list.ISCHED_VIEW_CODE) {
								self.selectedClass = self.$route.query.scheduleID;

								self.loadScheduler(self.getSelectedClass);
								self.loadScheduleWindow(self.getSelectedClass);
								classExists = true;
								break;
							}
						}

						if(!classExists && self.classList.length === 1) {
							self.selectedClass = self.classList[0].ISCHED_VIEW_CODE;

							self.loadScheduler(self.getSelectedClass);
							self.loadScheduleWindow(self.getSelectedClass);
						}
					}
				});
			},
			loadScheduleWindow(currentClass) {
				let self = this;

				let scheduleWindow = new ScheduleWindow({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						isched_view_code: currentClass.ISCHED_VIEW_CODE,
						school_id: currentClass.SCHOOL_ID,
						school_year: currentClass.SCHOOL_YEAR
					}
				});

				const promise = scheduleWindow.get();

				promise.then(response => {
					self.$set(self, 'scheduleWindow', scheduleWindow.getResponseData());
				});
			},
			loadScheduler(currentClass) {
				let self = this;

				let studentSchedule = new StudentSchedule({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						isched_view_code: currentClass.ISCHED_VIEW_CODE,
						school_id: currentClass.SCHOOL_ID,
						school_year: currentClass.SCHOOL_YEAR
					}
				});

				const promise = studentSchedule.get();

				promise.then(response => {
					self.$set(self, 'selectedCourse', studentSchedule.getResponseData());

					for(let m in self.selectedCourse.CLASSES) {
						let mp = self.selectedCourse.CLASSES[m];

						for(let d in mp) {
							let days = mp[d];

							for(let i in days) {
								let day = days[i];

								if(!!day.COURSE_CATALOG_DESC) {
									let str = day.COURSE_CATALOG_DESC;
									str = str.replace(/\n/g, '<br />');

									self.$set(day, 'COURSE_CATALOG_DESC', str);
								}
							}
						}
					}
				});
			},
			getPrintScheduleLink() {
				let studentSchedule = new StudentSchedule({
					route: 'interactive-schedules/print-url',
					query: {
						student_rid: 		this.selectedStudent.STUDENT_RID,
						school_id: 			this.getSelectedClass.SCHOOL_ID,
						school_year: 		this.getSelectedClass.SCHOOL_YEAR,
						isched_view_code:	this.getSelectedClass.ISCHED_VIEW_CODE,
					}
				});

				studentSchedule.get().then(response => {
					this.$set(this, 'printLink', response.data);
				});
			},
			loadAvailableCourses(mp, period, day) {
				const self = this;

				let classes = new AvailableClasses({
					routeParams: {
						setting: 'available-classes'
					},
					query: {
						student_rid:			self.selectedStudent.STUDENT_RID,
						school_id:				self.getSelectedClass.SCHOOL_ID,
						school_year:			self.getSelectedClass.SCHOOL_YEAR,
						isched_view_code:	self.getSelectedClass.ISCHED_VIEW_CODE,
						mp_code:					mp,
						period_code:			period,
						day_code:					day
					}
				});

				const promise = classes.get();

				promise.then(response => {
					self.$set(self, 'availableCourses', classes.getResponseData());
					self.showModal = true;
				});
			},
			addCourse(course) {
				if (this.getSelectedClass.STUDENT_MAY_ADD_FLG !== 'Y' || course.IS_CONFLICT_FLG !== 'N') {
					console.log('permission not allowed');
					return;
				}

				const msg = this.$t('MAIN_CONTENT.InteractiveScheduler.confirmAddClassMessage');
				const title = this.$t('MAIN_CONTENT.InteractiveScheduler.confirmAddClassTitle');
				const okTxt = this.$t('MAIN_CONTENT.InteractiveScheduler.confirmAddClassOkText');
				const cancelTxt = this.$t('commonText.cancel');

				this.closeModal();

				
				this.$nextTick(() => {
					this.$modal.confirm(msg, { title, okText: okTxt, cancelText: cancelTxt })
						.then(ans => {
							let classes = new StudentSchedule({
								routeParams: { setting: 'student-schedule' },
								query: {
									student_rid: this.selectedStudent.STUDENT_RID,
									school_id: course.SCHOOL_ID,
									school_year: this.selectedCourse.SCHOOL_YEAR,
									isched_view_code: this.selectedCourse.ISCHED_VIEW_CODE
								},
								data: { courseSectionGuid: course.COURSE_SECTION_GUID }
							});

							classes.put().then(response => {
								this.$set(this, 'messages', classes.getResponseMessages());
								this.loadScheduler(this.getSelectedClass);
							});
						}, () => {
							// Cancelled  bring the class picker back
							this.showModal = true;
						});
				});
				
			},
			removeCourse(selectedMatrixCell) {
				const self = this;

				let classes = new StudentSchedule({
						routeParams: {
							setting: 'student-schedule'
						},
						query: {
							student_rid: self.selectedStudent.STUDENT_RID,
							school_id: self.selectedCourse.SCHOOL_ID,
							school_year: 		self.selectedCourse.SCHOOL_YEAR,
							isched_view_code: self.selectedCourse.ISCHED_VIEW_CODE
						},
						data: {
							mpCode: selectedMatrixCell.mp,
							periodCode: selectedMatrixCell.period,
							dayCode: selectedMatrixCell.day
						}
					});

					const promise = classes.post();

					promise.then(response => {
					this.$set(this, 'messages', classes.getResponseMessages());
					this.loadScheduler(this.getSelectedClass);
				})
				.finally(() => {
					this.showConfirm = false;
				});
			},
			closeModal() {
				this.showModal = false;
			},
			updateConfirm(value) {
				this.showConfirm = typeof value === 'boolean' ? value : !this.showConfirm;
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'hand-pointer');
			this.$store.commit('setTitle', 'MAIN_CONTENT.InteractiveScheduler.sideMenuInteractiveSchedulerLink');
			this.$store.commit('setUseHeader', true);

			this.loadClassList();
		}
	}
</script>
